import * as arrowChevronDown$1 from "./solid/arrow-chevron-down.svg.js";
import * as arrowChevronLeft$1 from "./solid/arrow-chevron-left.svg.js";
import * as arrowChevronRight$1 from "./solid/arrow-chevron-right.svg.js";
import * as arrowChevronUp$1 from "./solid/arrow-chevron-up.svg.js";
import * as arrowDown$1 from "./solid/arrow-down.svg.js";
import * as arrowLeft$1 from "./solid/arrow-left.svg.js";
import * as arrowRight$1 from "./solid/arrow-right.svg.js";
import * as arrowUp$1 from "./solid/arrow-up.svg.js";
import * as basicShapeDiamond$1 from "./solid/basic-shape-diamond.svg.js";
import * as basicShapeHexagon$1 from "./solid/basic-shape-hexagon.svg.js";
import * as basicShapePrimaryCircleEllipseRound$1 from "./solid/basic-shape-primary-circle-ellipse-round.svg.js";
import * as basicShapePrimarySquareRectangle$1 from "./solid/basic-shape-primary-square-rectangle.svg.js";
import * as basicShapeShield$1 from "./solid/basic-shape-shield.svg.js";
import * as computerDeviceDesktopMonitor$1 from "./solid/computer-device-desktop-monitor.svg.js";
import * as computerDeviceDesktop$1 from "./solid/computer-device-desktop.svg.js";
import * as computerDeviceLaptop$1 from "./solid/computer-device-laptop.svg.js";
import * as computerDeviceMobilePhoneAndroidSamsungBack$1 from "./solid/computer-device-mobile-phone-android-samsung-back.svg.js";
import * as computerDeviceMobilePhoneAndroidSamsung$1 from "./solid/computer-device-mobile-phone-android-samsung.svg.js";
import * as computerDeviceMobilePhoneIphoneXBack$1 from "./solid/computer-device-mobile-phone-iphone-x-back.svg.js";
import * as computerDeviceMobilePhoneIphoneX$1 from "./solid/computer-device-mobile-phone-iphone-x.svg.js";
import * as computerDeviceMobileTabletTouch$1 from "./solid/computer-device-mobile-tablet-touch.svg.js";
import * as computerDeviceMobileTablet$1 from "./solid/computer-device-mobile-tablet.svg.js";
import * as computerDeviceNetworkEthernetCat6$1 from "./solid/computer-device-network-ethernet-cat6.svg.js";
import * as computerDeviceNetworkLanWww$1 from "./solid/computer-device-network-lan-www.svg.js";
import * as computerDeviceNetworkWifiConnection$1 from "./solid/computer-device-network-wifi-connection.svg.js";
import * as computerDeviceNetworkWifiRouter$1 from "./solid/computer-device-network-wifi-router.svg.js";
import * as computerKeyboardAlt$1 from "./solid/computer-keyboard-alt.svg.js";
import * as computerKeyboardCommandCmdControlCtrl$1 from "./solid/computer-keyboard-command-cmd-control-ctrl.svg.js";
import * as computerKeyboardOption$1 from "./solid/computer-keyboard-option.svg.js";
import * as computerKeyboardShift$1 from "./solid/computer-keyboard-shift.svg.js";
import * as ecologyScienceErlenmeyerFlask$1 from "./solid/ecology-science-erlenmeyer-flask.svg.js";
import * as entertainmentControlButtonCircleLeftArrowRewind$1 from "./solid/entertainment-control-button-circle-left-arrow-rewind.svg.js";
import * as entertainmentControlButtonCirclePause$1 from "./solid/entertainment-control-button-circle-pause.svg.js";
import * as entertainmentControlButtonCirclePlay from "./solid/entertainment-control-button-circle-play.svg.js";
import * as entertainmentControlButtonCircleRightArrowFastForward$1 from "./solid/entertainment-control-button-circle-right-arrow-fast-forward.svg.js";
import * as entertainmentControlButtonCircleStopSquare$1 from "./solid/entertainment-control-button-circle-stop-square.svg.js";
import * as entertainmentPartyPopperConfetti$1 from "./solid/entertainment-party-popper-confetti.svg.js";
import * as imageFlashLightning$1 from "./solid/image-flash-lightning.svg.js";
import * as imagePhotoFrame$1 from "./solid/image-photo-frame.svg.js";
import * as imagePictureFlower$1 from "./solid/image-picture-flower.svg.js";
import * as interfaceAddSquare from "./solid/interface-add-square.svg.js";
import * as interfaceAlertErrorExclamationBlockSquare$1 from "./solid/interface-alert-error-exclamation-block-square.svg.js";
import * as interfaceAlertErrorXBlockSquare$1 from "./solid/interface-alert-error-x-block-square.svg.js";
import * as interfaceAlertExclamationDiamond$1 from "./solid/interface-alert-exclamation-diamond.svg.js";
import * as interfaceAlertExclamationTriangleWarning$1 from "./solid/interface-alert-exclamation-triangle-warning.svg.js";
import * as interfaceAlertInformationCircle$1 from "./solid/interface-alert-information-circle.svg.js";
import * as interfaceAwardCrown$1 from "./solid/interface-award-crown.svg.js";
import * as interfaceBookmarkTag$1 from "./solid/interface-bookmark-tag.svg.js";
import * as interfaceBookmark$1 from "./solid/interface-bookmark.svg.js";
import * as interfaceCalendarDateOne$1 from "./solid/interface-calendar-date-one.svg.js";
import * as interfaceClose$1 from "./solid/interface-close.svg.js";
import * as interfaceContentBookOpenPages$1 from "./solid/interface-content-book-open-pages.svg.js";
import * as interfaceContentBookPage$1 from "./solid/interface-content-book-page.svg.js";
import * as interfaceContentFile$1 from "./solid/interface-content-file.svg.js";
import * as interfaceContentFolder$1 from "./solid/interface-content-folder.svg.js";
import * as interfaceCopyClipboard$1 from "./solid/interface-copy-clipboard.svg.js";
import * as interfaceDeleteBinTrash$1 from "./solid/interface-delete-bin-trash.svg.js";
import * as interfaceDotsHorizontal$1 from "./solid/interface-dots-horizontal.svg.js";
import * as interfaceDotsVertical$1 from "./solid/interface-dots-vertical.svg.js";
import * as interfaceEditAttachment$1 from "./solid/interface-edit-attachment.svg.js";
import * as interfaceEditBinocular$1 from "./solid/interface-edit-binocular.svg.js";
import * as interfaceEditMagicWand$1 from "./solid/interface-edit-magic-wand.svg.js";
import * as interfaceEditToolEraser$1 from "./solid/interface-edit-tool-eraser.svg.js";
import * as interfaceEditToolPaintBrush$1 from "./solid/interface-edit-tool-paint-brush.svg.js";
import * as interfaceEditToolPaintRoller$1 from "./solid/interface-edit-tool-paint-roller.svg.js";
import * as interfaceEditToolPen$1 from "./solid/interface-edit-tool-pen.svg.js";
import * as interfaceEditToolPencil$1 from "./solid/interface-edit-tool-pencil.svg.js";
import * as interfaceEditViewEye$1 from "./solid/interface-edit-view-eye.svg.js";
import * as interfaceFavoriteAward$1 from "./solid/interface-favorite-award.svg.js";
import * as interfaceFavoriteFlag$1 from "./solid/interface-favorite-flag.svg.js";
import * as interfaceFavoriteHeart$1 from "./solid/interface-favorite-heart.svg.js";
import * as interfaceFavoriteStar$1 from "./solid/interface-favorite-star.svg.js";
import * as interfaceFavoriteStarsShining$1 from "./solid/interface-favorite-stars-shining.svg.js";
import * as interfaceFavoriteStarsSparkles$1 from "./solid/interface-favorite-stars-sparkles.svg.js";
import * as interfaceHierarchyFlowchart$1 from "./solid/interface-hierarchy-flowchart.svg.js";
import * as interfaceHomeHouse$1 from "./solid/interface-home-house.svg.js";
import * as interfaceHyperlink$1 from "./solid/interface-hyperlink.svg.js";
import * as interfaceLightingBrightness$1 from "./solid/interface-lighting-brightness.svg.js";
import * as interfaceLockClosed$1 from "./solid/interface-lock-closed.svg.js";
import * as interfaceLockOpenUnlock$1 from "./solid/interface-lock-open-unlock.svg.js";
import * as interfaceLoginKey$1 from "./solid/interface-login-key.svg.js";
import * as interfaceSearch$1 from "./solid/interface-search.svg.js";
import * as interfaceSettingCog$1 from "./solid/interface-setting-cog.svg.js";
import * as interfaceShareMegaphoneBullhorn$1 from "./solid/interface-share-megaphone-bullhorn.svg.js";
import * as interfaceShareRocket$1 from "./solid/interface-share-rocket.svg.js";
import * as interfaceShareSatellite$1 from "./solid/interface-share-satellite.svg.js";
import * as interfaceShareSpaceShip$1 from "./solid/interface-share-space-ship.svg.js";
import * as interfaceShare$1 from "./solid/interface-share.svg.js";
import * as interfaceSignalSquare$1 from "./solid/interface-signal-square.svg.js";
import * as interfaceTextFormattingLeftOpenQuote$1 from "./solid/interface-text-formatting-left-open-quote.svg.js";
import * as interfaceTextFormattingRightCloseQuote$1 from "./solid/interface-text-formatting-right-close-quote.svg.js";
import * as interfaceTimeClockCircle$1 from "./solid/interface-time-clock-circle.svg.js";
import * as interfaceTimeHourGlass$1 from "./solid/interface-time-hour-glass.svg.js";
import * as interfaceUsersMultiple$1 from "./solid/interface-users-multiple.svg.js";
import * as interfaceValidationCheckboxSquare$1 from "./solid/interface-validation-checkbox-square.svg.js";
import * as interfaceWeatherMoon$1 from "./solid/interface-weather-moon.svg.js";
import * as legalJusticeHammerGavel$1 from "./solid/legal-justice-hammer-gavel.svg.js";
import * as mailChatBubbleSquare$1 from "./solid/mail-chat-bubble-square.svg.js";
import * as mailSendEmailPaperAirplane$1 from "./solid/mail-send-email-paper-airplane.svg.js";
import * as mailSendEnvelope$1 from "./solid/mail-send-envelope.svg.js";
import * as mailSignHashtag$1 from "./solid/mail-sign-hashtag.svg.js";
import * as moneyCashierReceipt$1 from "./solid/money-cashier-receipt.svg.js";
import * as moneyCurrencyDollarPay$1 from "./solid/money-currency-dollar-pay.svg.js";
import * as moneyGraphArrowIncrease$1 from "./solid/money-graph-arrow-increase.svg.js";
import * as moneyGraphBarChartIncrease$1 from "./solid/money-graph-bar-chart-increase.svg.js";
import * as natureEcologyLeaf$1 from "./solid/nature-ecology-leaf.svg.js";
import * as phoneTelephone$1 from "./solid/phone-telephone.svg.js";
import * as programmingBug$1 from "./solid/programming-bug.svg.js";
import * as programmingCloud$1 from "./solid/programming-cloud.svg.js";
import * as programmingComputerDatabaseServer$1 from "./solid/programming-computer-database-server.svg.js";
import * as programmingComputerDatabase$1 from "./solid/programming-computer-database.svg.js";
import * as programmingModuleFourLayout$1 from "./solid/programming-module-four-layout.svg.js";
import * as programmingModuleThree$1 from "./solid/programming-module-three.svg.js";
import * as programmingModule$1 from "./solid/programming-module.svg.js";
import * as programmingScriptCode$1 from "./solid/programming-script-code.svg.js";
import * as shoppingCart$1 from "./solid/shopping-cart.svg.js";
import * as shoppingGiftPresent$1 from "./solid/shopping-gift-present.svg.js";
import * as shoppingShippingBoxParcelPackage$1 from "./solid/shopping-shipping-box-parcel-package.svg.js";
import * as tagNewCircle$1 from "./solid/tag-new-circle.svg.js";
import * as travelMapEarthGlobe$1 from "./solid/travel-map-earth-globe.svg.js";
import * as arrowChevronDown from "./line/arrow-chevron-down.svg.js";
import * as arrowChevronLeft from "./line/arrow-chevron-left.svg.js";
import * as arrowChevronRight from "./line/arrow-chevron-right.svg.js";
import * as arrowChevronUp from "./line/arrow-chevron-up.svg.js";
import * as arrowDown from "./line/arrow-down.svg.js";
import * as arrowLeft from "./line/arrow-left.svg.js";
import * as arrowRight from "./line/arrow-right.svg.js";
import * as arrowUp from "./line/arrow-up.svg.js";
import * as basicShapeDiamond from "./line/basic-shape-diamond.svg.js";
import * as basicShapeHexagon from "./line/basic-shape-hexagon.svg.js";
import * as basicShapePrimaryCircleEllipseRound from "./line/basic-shape-primary-circle-ellipse-round.svg.js";
import * as basicShapePrimarySquareRectangle from "./line/basic-shape-primary-square-rectangle.svg.js";
import * as basicShapeShield from "./line/basic-shape-shield.svg.js";
import * as computerDeviceDesktopMonitor from "./line/computer-device-desktop-monitor.svg.js";
import * as computerDeviceDesktop from "./line/computer-device-desktop.svg.js";
import * as computerDeviceLaptop from "./line/computer-device-laptop.svg.js";
import * as computerDeviceMobilePhoneAndroidSamsungBack from "./line/computer-device-mobile-phone-android-samsung-back.svg.js";
import * as computerDeviceMobilePhoneAndroidSamsung from "./line/computer-device-mobile-phone-android-samsung.svg.js";
import * as computerDeviceMobilePhoneIphoneXBack from "./line/computer-device-mobile-phone-iphone-x-back.svg.js";
import * as computerDeviceMobilePhoneIphoneX from "./line/computer-device-mobile-phone-iphone-x.svg.js";
import * as computerDeviceMobileTabletTouch from "./line/computer-device-mobile-tablet-touch.svg.js";
import * as computerDeviceMobileTablet from "./line/computer-device-mobile-tablet.svg.js";
import * as computerDeviceNetworkEthernetCat6 from "./line/computer-device-network-ethernet-cat6.svg.js";
import * as computerDeviceNetworkLanWww from "./line/computer-device-network-lan-www.svg.js";
import * as computerDeviceNetworkWifiConnection from "./line/computer-device-network-wifi-connection.svg.js";
import * as computerDeviceNetworkWifiRouter from "./line/computer-device-network-wifi-router.svg.js";
import * as computerKeyboardAlt from "./line/computer-keyboard-alt.svg.js";
import * as computerKeyboardCommandCmdControlCtrl from "./line/computer-keyboard-command-cmd-control-ctrl.svg.js";
import * as computerKeyboardOption from "./line/computer-keyboard-option.svg.js";
import * as computerKeyboardShift from "./line/computer-keyboard-shift.svg.js";
import * as ecologyScienceErlenmeyerFlask from "./line/ecology-science-erlenmeyer-flask.svg.js";
import * as entertainmentControlButtonCircleLeftArrowRewind from "./line/entertainment-control-button-circle-left-arrow-rewind.svg.js";
import * as entertainmentControlButtonCirclePause from "./line/entertainment-control-button-circle-pause.svg.js";
import * as entertainmentControlButtonCircleRightArrowFastForward from "./line/entertainment-control-button-circle-right-arrow-fast-forward.svg.js";
import * as entertainmentControlButtonCircleStopSquare from "./line/entertainment-control-button-circle-stop-square.svg.js";
import * as entertainmentControlButtonPlayCircle from "./line/entertainment-control-button-play-circle.svg.js";
import * as entertainmentPartyPopperConfetti from "./line/entertainment-party-popper-confetti.svg.js";
import * as imageFlashLightning from "./line/image-flash-lightning.svg.js";
import * as imagePhotoFrame from "./line/image-photo-frame.svg.js";
import * as imagePictureFlower from "./line/image-picture-flower.svg.js";
import * as interfaceAdd from "./line/interface-add.svg.js";
import * as interfaceAlertErrorExclamationBlockSquare from "./line/interface-alert-error-exclamation-block-square.svg.js";
import * as interfaceAlertErrorXBlockSquare from "./line/interface-alert-error-x-block-square.svg.js";
import * as interfaceAlertExclamationDiamond from "./line/interface-alert-exclamation-diamond.svg.js";
import * as interfaceAlertExclamationTriangleWarning from "./line/interface-alert-exclamation-triangle-warning.svg.js";
import * as interfaceAlertInformationCircle from "./line/interface-alert-information-circle.svg.js";
import * as interfaceAwardCrown from "./line/interface-award-crown.svg.js";
import * as interfaceBookmarkTag from "./line/interface-bookmark-tag.svg.js";
import * as interfaceBookmark from "./line/interface-bookmark.svg.js";
import * as interfaceCalendarDateOne from "./line/interface-calendar-date-one.svg.js";
import * as interfaceClose from "./line/interface-close.svg.js";
import * as interfaceContentBookOpenPages from "./line/interface-content-book-open-pages.svg.js";
import * as interfaceContentBookPage from "./line/interface-content-book-page.svg.js";
import * as interfaceContentFile from "./line/interface-content-file.svg.js";
import * as interfaceContentFolder from "./line/interface-content-folder.svg.js";
import * as interfaceCopyClipboard from "./line/interface-copy-clipboard.svg.js";
import * as interfaceDeleteBinTrash from "./line/interface-delete-bin-trash.svg.js";
import * as interfaceDotsHorizontal from "./line/interface-dots-horizontal.svg.js";
import * as interfaceDotsVertical from "./line/interface-dots-vertical.svg.js";
import * as interfaceEditAttachment from "./line/interface-edit-attachment.svg.js";
import * as interfaceEditBinocular from "./line/interface-edit-binocular.svg.js";
import * as interfaceEditMagicWand from "./line/interface-edit-magic-wand.svg.js";
import * as interfaceEditToolEraser from "./line/interface-edit-tool-eraser.svg.js";
import * as interfaceEditToolPaintBrush from "./line/interface-edit-tool-paint-brush.svg.js";
import * as interfaceEditToolPaintRoller from "./line/interface-edit-tool-paint-roller.svg.js";
import * as interfaceEditToolPen from "./line/interface-edit-tool-pen.svg.js";
import * as interfaceEditToolPencil from "./line/interface-edit-tool-pencil.svg.js";
import * as interfaceEditViewEye from "./line/interface-edit-view-eye.svg.js";
import * as interfaceFavoriteAward from "./line/interface-favorite-award.svg.js";
import * as interfaceFavoriteFlag from "./line/interface-favorite-flag.svg.js";
import * as interfaceFavoriteHeart from "./line/interface-favorite-heart.svg.js";
import * as interfaceFavoriteStar from "./line/interface-favorite-star.svg.js";
import * as interfaceFavoriteStarsShining from "./line/interface-favorite-stars-shining.svg.js";
import * as interfaceFavoriteStarsSparkles from "./line/interface-favorite-stars-sparkles.svg.js";
import * as interfaceHierarchyFlowchart from "./line/interface-hierarchy-flowchart.svg.js";
import * as interfaceHomeHouse from "./line/interface-home-house.svg.js";
import * as interfaceHyperlink from "./line/interface-hyperlink.svg.js";
import * as interfaceLightingBrightness from "./line/interface-lighting-brightness.svg.js";
import * as interfaceLockClosed from "./line/interface-lock-closed.svg.js";
import * as interfaceLockOpenUnlock from "./line/interface-lock-open-unlock.svg.js";
import * as interfaceLoginKey from "./line/interface-login-key.svg.js";
import * as interfaceSearch from "./line/interface-search.svg.js";
import * as interfaceSettingCog from "./line/interface-setting-cog.svg.js";
import * as interfaceShareMegaphoneBullhorn from "./line/interface-share-megaphone-bullhorn.svg.js";
import * as interfaceShareRocket from "./line/interface-share-rocket.svg.js";
import * as interfaceShareSatellite from "./line/interface-share-satellite.svg.js";
import * as interfaceShareSpaceShip from "./line/interface-share-space-ship.svg.js";
import * as interfaceShare from "./line/interface-share.svg.js";
import * as interfaceSignalSquare from "./line/interface-signal-square.svg.js";
import * as interfaceTextFormattingLeftOpenQuote from "./line/interface-text-formatting-left-open-quote.svg.js";
import * as interfaceTextFormattingRightCloseQuote from "./line/interface-text-formatting-right-close-quote.svg.js";
import * as interfaceTimeClockCircle from "./line/interface-time-clock-circle.svg.js";
import * as interfaceTimeHourGlass from "./line/interface-time-hour-glass.svg.js";
import * as interfaceUsersMultiple from "./line/interface-users-multiple.svg.js";
import * as interfaceValidationCheckboxSquare from "./line/interface-validation-checkbox-square.svg.js";
import * as interfaceWeatherMoon from "./line/interface-weather-moon.svg.js";
import * as legalJusticeHammerGavel from "./line/legal-justice-hammer-gavel.svg.js";
import * as mailChatBubbleSquare from "./line/mail-chat-bubble-square.svg.js";
import * as mailSendEmailPaperAirplane from "./line/mail-send-email-paper-airplane.svg.js";
import * as mailSendEnvelope from "./line/mail-send-envelope.svg.js";
import * as mailSignHashtag from "./line/mail-sign-hashtag.svg.js";
import * as moneyCashierReceipt from "./line/money-cashier-receipt.svg.js";
import * as moneyCurrencyDollarPay from "./line/money-currency-dollar-pay.svg.js";
import * as moneyGraphArrowIncrease from "./line/money-graph-arrow-increase.svg.js";
import * as moneyGraphBarChartIncrease from "./line/money-graph-bar-chart-increase.svg.js";
import * as natureEcologyLeaf from "./line/nature-ecology-leaf.svg.js";
import * as phoneTelephone from "./line/phone-telephone.svg.js";
import * as programmingBug from "./line/programming-bug.svg.js";
import * as programmingCloud from "./line/programming-cloud.svg.js";
import * as programmingComputerDatabaseServer from "./line/programming-computer-database-server.svg.js";
import * as programmingComputerDatabase from "./line/programming-computer-database.svg.js";
import * as programmingModuleFourLayout from "./line/programming-module-four-layout.svg.js";
import * as programmingModuleThree from "./line/programming-module-three.svg.js";
import * as programmingModule from "./line/programming-module.svg.js";
import * as programmingScriptCode from "./line/programming-script-code.svg.js";
import * as shoppingCart from "./line/shopping-cart.svg.js";
import * as shoppingGiftPresent from "./line/shopping-gift-present.svg.js";
import * as shoppingShippingBoxParcelPackage from "./line/shopping-shipping-box-parcel-package.svg.js";
import * as tagNewCircle from "./line/tag-new-circle.svg.js";
import * as travelMapEarthGlobe from "./line/travel-map-earth-globe.svg.js";
import * as brandAdobe from "./brand/brand-adobe.svg.js";
import * as brandAmazon from "./brand/brand-amazon.svg.js";
import * as brandBrowserFirefox from "./brand/brand-browser-firefox.svg.js";
import * as brandBrowserGooglechrome from "./brand/brand-browser-googlechrome.svg.js";
import * as brandCreativeCommons from "./brand/brand-creative-commons.svg.js";
import * as brandEcommerceEtsy from "./brand/brand-ecommerce-etsy.svg.js";
import * as brandEcommercePatreon from "./brand/brand-ecommerce-patreon.svg.js";
import * as brandEcommerceShopify from "./brand/brand-ecommerce-shopify.svg.js";
import * as brandEcommerceWordpress from "./brand/brand-ecommerce-wordpress.svg.js";
import * as brandGamingNintendoSwitch from "./brand/brand-gaming-nintendo-switch.svg.js";
import * as brandGamingPlaystation from "./brand/brand-gaming-playstation.svg.js";
import * as brandGamingXboxLive from "./brand/brand-gaming-xbox-live.svg.js";
import * as brandGoogleDrive from "./brand/brand-google-drive.svg.js";
import * as brandGoogleGmail from "./brand/brand-google-gmail.svg.js";
import * as brandGoogle from "./brand/brand-google.svg.js";
import * as brandMusicItunes from "./brand/brand-music-itunes.svg.js";
import * as brandMusicSoundcloud from "./brand/brand-music-soundcloud.svg.js";
import * as brandMusicSpotify from "./brand/brand-music-spotify.svg.js";
import * as brandOfficeDropbox from "./brand/brand-office-dropbox.svg.js";
import * as brandOfficeSlack from "./brand/brand-office-slack.svg.js";
import * as brandOfficeZoom from "./brand/brand-office-zoom.svg.js";
import * as brandPaymentsAlipay from "./brand/brand-payments-alipay.svg.js";
import * as brandPaymentsPaypal from "./brand/brand-payments-paypal.svg.js";
import * as brandPaymentsStripe from "./brand/brand-payments-stripe.svg.js";
import * as brandPlatformAndroid from "./brand/brand-platform-android.svg.js";
import * as brandPlatformApple from "./brand/brand-platform-apple.svg.js";
import * as brandPlatformLinux from "./brand/brand-platform-linux.svg.js";
import * as brandPlatformMicrosoftWindows from "./brand/brand-platform-microsoft-windows.svg.js";
import * as brandSocialChatDiscord from "./brand/brand-social-chat-discord.svg.js";
import * as brandSocialChatKuaishou from "./brand/brand-social-chat-kuaishou.svg.js";
import * as brandSocialChatLine from "./brand/brand-social-chat-line.svg.js";
import * as brandSocialChatMessenger from "./brand/brand-social-chat-messenger.svg.js";
import * as brandSocialChatSignal from "./brand/brand-social-chat-signal.svg.js";
import * as brandSocialChatSnapchat from "./brand/brand-social-chat-snapchat.svg.js";
import * as brandSocialChatTelegram from "./brand/brand-social-chat-telegram.svg.js";
import * as brandSocialChatWechat from "./brand/brand-social-chat-wechat.svg.js";
import * as brandSocialChatWhatsapp from "./brand/brand-social-chat-whatsapp.svg.js";
import * as brandSocialMediaDeviantart from "./brand/brand-social-media-deviantart.svg.js";
import * as brandSocialMediaDribbble from "./brand/brand-social-media-dribbble.svg.js";
import * as brandSocialMediaFacebook from "./brand/brand-social-media-facebook.svg.js";
import * as brandSocialMediaInstagram from "./brand/brand-social-media-instagram.svg.js";
import * as brandSocialMediaLinkedin from "./brand/brand-social-media-linkedin.svg.js";
import * as brandSocialMediaPinterest from "./brand/brand-social-media-pinterest.svg.js";
import * as brandSocialMediaReddit from "./brand/brand-social-media-reddit.svg.js";
import * as brandSocialMediaSinaWeibo from "./brand/brand-social-media-sina-weibo.svg.js";
import * as brandSocialMediaThreads from "./brand/brand-social-media-threads.svg.js";
import * as brandSocialMediaTiktok from "./brand/brand-social-media-tiktok.svg.js";
import * as brandSocialMediaTinder from "./brand/brand-social-media-tinder.svg.js";
import * as brandSocialMediaTumblr from "./brand/brand-social-media-tumblr.svg.js";
import * as brandSocialMediaTwitter from "./brand/brand-social-media-twitter.svg.js";
import * as brandSoftwareDesignFigma from "./brand/brand-software-design-figma.svg.js";
import * as brandSoftwareDevelopmentAuthy from "./brand/brand-software-development-authy.svg.js";
import * as brandSoftwareDevelopmentDigitalOcean from "./brand/brand-software-development-digital-ocean.svg.js";
import * as brandSoftwareDevelopmentDocker from "./brand/brand-software-development-docker.svg.js";
import * as brandSoftwareDevelopmentGithub from "./brand/brand-software-development-github.svg.js";
import * as brandSoftwareDevelopmentJira from "./brand/brand-software-development-jira.svg.js";
import * as brandSoftwareDevelopmentOpenai from "./brand/brand-software-development-openai.svg.js";
import * as brandSoftwareDevelopmentStackexchange from "./brand/brand-software-development-stackexchange.svg.js";
import * as brandSoftwareDevelopmentStackoverflow from "./brand/brand-software-development-stackoverflow.svg.js";
import * as brandVideoNetflix from "./brand/brand-video-netflix.svg.js";
import * as brandVideoTwitch from "./brand/brand-video-twitch.svg.js";
import * as brandVideoVimeo from "./brand/brand-video-vimeo.svg.js";
import * as brandVideoYoutube from "./brand/brand-video-youtube.svg.js";
import * as programmingFrameworkAngular from "./brand/programming-framework-angular.svg.js";
import * as programmingFrameworkAstro from "./brand/programming-framework-astro.svg.js";
import * as programmingFrameworkLaravel from "./brand/programming-framework-laravel.svg.js";
import * as programmingFrameworkNextdotjs from "./brand/programming-framework-nextdotjs.svg.js";
import * as programmingFrameworkReact from "./brand/programming-framework-react.svg.js";
import * as programmingFrameworkVuedotjs from "./brand/programming-framework-vuedotjs.svg.js";
import * as programmingLanguageC from "./brand/programming-language-c.svg.js";
import * as programmingLanguageClojure from "./brand/programming-language-clojure.svg.js";
import * as programmingLanguageCsharp from "./brand/programming-language-csharp.svg.js";
import * as programmingLanguageCss3 from "./brand/programming-language-css3.svg.js";
import * as programmingLanguageGo from "./brand/programming-language-go.svg.js";
import * as programmingLanguageHtml5 from "./brand/programming-language-html5.svg.js";
import * as programmingLanguageJava from "./brand/programming-language-java.svg.js";
import * as programmingLanguageJavascriptJs from "./brand/programming-language-javascript-js.svg.js";
import * as programmingLanguageJson from "./brand/programming-language-json.svg.js";
import * as programmingLanguageKotlin from "./brand/programming-language-kotlin.svg.js";
import * as programmingLanguageNode from "./brand/programming-language-node.svg.js";
import * as programmingLanguageObjc from "./brand/programming-language-objc.svg.js";
import * as programmingLanguageOcaml from "./brand/programming-language-ocaml.svg.js";
import * as programmingLanguagePhp from "./brand/programming-language-php.svg.js";
import * as programmingLanguagePowershell from "./brand/programming-language-powershell.svg.js";
import * as programmingLanguagePython from "./brand/programming-language-python.svg.js";
import * as programmingLanguageR from "./brand/programming-language-r.svg.js";
import * as programmingLanguageRuby from "./brand/programming-language-ruby.svg.js";
import * as programmingLanguageScala from "./brand/programming-language-scala.svg.js";
import * as programmingLanguageShell from "./brand/programming-language-shell.svg.js";
import * as programmingLanguageSwift from "./brand/programming-language-swift.svg.js";
import * as programmingLanguageTypescript from "./brand/programming-language-typescript.svg.js";
import * as programmingToolGit from "./brand/programming-tool-git.svg.js";
import * as programmingToolTailwindcss from "./brand/programming-tool-tailwindcss.svg.js";
const iconsSolid = /* @__PURE__ */ Object.assign({
  "./solid/arrow-chevron-down.svg": arrowChevronDown$1,
  "./solid/arrow-chevron-left.svg": arrowChevronLeft$1,
  "./solid/arrow-chevron-right.svg": arrowChevronRight$1,
  "./solid/arrow-chevron-up.svg": arrowChevronUp$1,
  "./solid/arrow-down.svg": arrowDown$1,
  "./solid/arrow-left.svg": arrowLeft$1,
  "./solid/arrow-right.svg": arrowRight$1,
  "./solid/arrow-up.svg": arrowUp$1,
  "./solid/basic-shape-diamond.svg": basicShapeDiamond$1,
  "./solid/basic-shape-hexagon.svg": basicShapeHexagon$1,
  "./solid/basic-shape-primary-circle-ellipse-round.svg": basicShapePrimaryCircleEllipseRound$1,
  "./solid/basic-shape-primary-square-rectangle.svg": basicShapePrimarySquareRectangle$1,
  "./solid/basic-shape-shield.svg": basicShapeShield$1,
  "./solid/computer-device-desktop-monitor.svg": computerDeviceDesktopMonitor$1,
  "./solid/computer-device-desktop.svg": computerDeviceDesktop$1,
  "./solid/computer-device-laptop.svg": computerDeviceLaptop$1,
  "./solid/computer-device-mobile-phone-android-samsung-back.svg": computerDeviceMobilePhoneAndroidSamsungBack$1,
  "./solid/computer-device-mobile-phone-android-samsung.svg": computerDeviceMobilePhoneAndroidSamsung$1,
  "./solid/computer-device-mobile-phone-iphone-x-back.svg": computerDeviceMobilePhoneIphoneXBack$1,
  "./solid/computer-device-mobile-phone-iphone-x.svg": computerDeviceMobilePhoneIphoneX$1,
  "./solid/computer-device-mobile-tablet-touch.svg": computerDeviceMobileTabletTouch$1,
  "./solid/computer-device-mobile-tablet.svg": computerDeviceMobileTablet$1,
  "./solid/computer-device-network-ethernet-cat6.svg": computerDeviceNetworkEthernetCat6$1,
  "./solid/computer-device-network-lan-www.svg": computerDeviceNetworkLanWww$1,
  "./solid/computer-device-network-wifi-connection.svg": computerDeviceNetworkWifiConnection$1,
  "./solid/computer-device-network-wifi-router.svg": computerDeviceNetworkWifiRouter$1,
  "./solid/computer-keyboard-alt.svg": computerKeyboardAlt$1,
  "./solid/computer-keyboard-command-cmd-control-ctrl.svg": computerKeyboardCommandCmdControlCtrl$1,
  "./solid/computer-keyboard-option.svg": computerKeyboardOption$1,
  "./solid/computer-keyboard-shift.svg": computerKeyboardShift$1,
  "./solid/ecology-science-erlenmeyer-flask.svg": ecologyScienceErlenmeyerFlask$1,
  "./solid/entertainment-control-button-circle-left-arrow-rewind.svg": entertainmentControlButtonCircleLeftArrowRewind$1,
  "./solid/entertainment-control-button-circle-pause.svg": entertainmentControlButtonCirclePause$1,
  "./solid/entertainment-control-button-circle-play.svg": entertainmentControlButtonCirclePlay,
  "./solid/entertainment-control-button-circle-right-arrow-fast-forward.svg": entertainmentControlButtonCircleRightArrowFastForward$1,
  "./solid/entertainment-control-button-circle-stop-square.svg": entertainmentControlButtonCircleStopSquare$1,
  "./solid/entertainment-party-popper-confetti.svg": entertainmentPartyPopperConfetti$1,
  "./solid/image-flash-lightning.svg": imageFlashLightning$1,
  "./solid/image-photo-frame.svg": imagePhotoFrame$1,
  "./solid/image-picture-flower.svg": imagePictureFlower$1,
  "./solid/interface-add-square.svg": interfaceAddSquare,
  "./solid/interface-alert-error-exclamation-block-square.svg": interfaceAlertErrorExclamationBlockSquare$1,
  "./solid/interface-alert-error-x-block-square.svg": interfaceAlertErrorXBlockSquare$1,
  "./solid/interface-alert-exclamation-diamond.svg": interfaceAlertExclamationDiamond$1,
  "./solid/interface-alert-exclamation-triangle-warning.svg": interfaceAlertExclamationTriangleWarning$1,
  "./solid/interface-alert-information-circle.svg": interfaceAlertInformationCircle$1,
  "./solid/interface-award-crown.svg": interfaceAwardCrown$1,
  "./solid/interface-bookmark-tag.svg": interfaceBookmarkTag$1,
  "./solid/interface-bookmark.svg": interfaceBookmark$1,
  "./solid/interface-calendar-date-one.svg": interfaceCalendarDateOne$1,
  "./solid/interface-close.svg": interfaceClose$1,
  "./solid/interface-content-book-open-pages.svg": interfaceContentBookOpenPages$1,
  "./solid/interface-content-book-page.svg": interfaceContentBookPage$1,
  "./solid/interface-content-file.svg": interfaceContentFile$1,
  "./solid/interface-content-folder.svg": interfaceContentFolder$1,
  "./solid/interface-copy-clipboard.svg": interfaceCopyClipboard$1,
  "./solid/interface-delete-bin-trash.svg": interfaceDeleteBinTrash$1,
  "./solid/interface-dots-horizontal.svg": interfaceDotsHorizontal$1,
  "./solid/interface-dots-vertical.svg": interfaceDotsVertical$1,
  "./solid/interface-edit-attachment.svg": interfaceEditAttachment$1,
  "./solid/interface-edit-binocular.svg": interfaceEditBinocular$1,
  "./solid/interface-edit-magic-wand.svg": interfaceEditMagicWand$1,
  "./solid/interface-edit-tool-eraser.svg": interfaceEditToolEraser$1,
  "./solid/interface-edit-tool-paint-brush.svg": interfaceEditToolPaintBrush$1,
  "./solid/interface-edit-tool-paint-roller.svg": interfaceEditToolPaintRoller$1,
  "./solid/interface-edit-tool-pen.svg": interfaceEditToolPen$1,
  "./solid/interface-edit-tool-pencil.svg": interfaceEditToolPencil$1,
  "./solid/interface-edit-view-eye.svg": interfaceEditViewEye$1,
  "./solid/interface-favorite-award.svg": interfaceFavoriteAward$1,
  "./solid/interface-favorite-flag.svg": interfaceFavoriteFlag$1,
  "./solid/interface-favorite-heart.svg": interfaceFavoriteHeart$1,
  "./solid/interface-favorite-star.svg": interfaceFavoriteStar$1,
  "./solid/interface-favorite-stars-shining.svg": interfaceFavoriteStarsShining$1,
  "./solid/interface-favorite-stars-sparkles.svg": interfaceFavoriteStarsSparkles$1,
  "./solid/interface-hierarchy-flowchart.svg": interfaceHierarchyFlowchart$1,
  "./solid/interface-home-house.svg": interfaceHomeHouse$1,
  "./solid/interface-hyperlink.svg": interfaceHyperlink$1,
  "./solid/interface-lighting-brightness.svg": interfaceLightingBrightness$1,
  "./solid/interface-lock-closed.svg": interfaceLockClosed$1,
  "./solid/interface-lock-open-unlock.svg": interfaceLockOpenUnlock$1,
  "./solid/interface-login-key.svg": interfaceLoginKey$1,
  "./solid/interface-search.svg": interfaceSearch$1,
  "./solid/interface-setting-cog.svg": interfaceSettingCog$1,
  "./solid/interface-share-megaphone-bullhorn.svg": interfaceShareMegaphoneBullhorn$1,
  "./solid/interface-share-rocket.svg": interfaceShareRocket$1,
  "./solid/interface-share-satellite.svg": interfaceShareSatellite$1,
  "./solid/interface-share-space-ship.svg": interfaceShareSpaceShip$1,
  "./solid/interface-share.svg": interfaceShare$1,
  "./solid/interface-signal-square.svg": interfaceSignalSquare$1,
  "./solid/interface-text-formatting-left-open-quote.svg": interfaceTextFormattingLeftOpenQuote$1,
  "./solid/interface-text-formatting-right-close-quote.svg": interfaceTextFormattingRightCloseQuote$1,
  "./solid/interface-time-clock-circle.svg": interfaceTimeClockCircle$1,
  "./solid/interface-time-hour-glass.svg": interfaceTimeHourGlass$1,
  "./solid/interface-users-multiple.svg": interfaceUsersMultiple$1,
  "./solid/interface-validation-checkbox-square.svg": interfaceValidationCheckboxSquare$1,
  "./solid/interface-weather-moon.svg": interfaceWeatherMoon$1,
  "./solid/legal-justice-hammer-gavel.svg": legalJusticeHammerGavel$1,
  "./solid/mail-chat-bubble-square.svg": mailChatBubbleSquare$1,
  "./solid/mail-send-email-paper-airplane.svg": mailSendEmailPaperAirplane$1,
  "./solid/mail-send-envelope.svg": mailSendEnvelope$1,
  "./solid/mail-sign-hashtag.svg": mailSignHashtag$1,
  "./solid/money-cashier-receipt.svg": moneyCashierReceipt$1,
  "./solid/money-currency-dollar-pay.svg": moneyCurrencyDollarPay$1,
  "./solid/money-graph-arrow-increase.svg": moneyGraphArrowIncrease$1,
  "./solid/money-graph-bar-chart-increase.svg": moneyGraphBarChartIncrease$1,
  "./solid/nature-ecology-leaf.svg": natureEcologyLeaf$1,
  "./solid/phone-telephone.svg": phoneTelephone$1,
  "./solid/programming-bug.svg": programmingBug$1,
  "./solid/programming-cloud.svg": programmingCloud$1,
  "./solid/programming-computer-database-server.svg": programmingComputerDatabaseServer$1,
  "./solid/programming-computer-database.svg": programmingComputerDatabase$1,
  "./solid/programming-module-four-layout.svg": programmingModuleFourLayout$1,
  "./solid/programming-module-three.svg": programmingModuleThree$1,
  "./solid/programming-module.svg": programmingModule$1,
  "./solid/programming-script-code.svg": programmingScriptCode$1,
  "./solid/shopping-cart.svg": shoppingCart$1,
  "./solid/shopping-gift-present.svg": shoppingGiftPresent$1,
  "./solid/shopping-shipping-box-parcel-package.svg": shoppingShippingBoxParcelPackage$1,
  "./solid/tag-new-circle.svg": tagNewCircle$1,
  "./solid/travel-map-earth-globe.svg": travelMapEarthGlobe$1
});
const iconsLine = /* @__PURE__ */ Object.assign({
  "./line/arrow-chevron-down.svg": arrowChevronDown,
  "./line/arrow-chevron-left.svg": arrowChevronLeft,
  "./line/arrow-chevron-right.svg": arrowChevronRight,
  "./line/arrow-chevron-up.svg": arrowChevronUp,
  "./line/arrow-down.svg": arrowDown,
  "./line/arrow-left.svg": arrowLeft,
  "./line/arrow-right.svg": arrowRight,
  "./line/arrow-up.svg": arrowUp,
  "./line/basic-shape-diamond.svg": basicShapeDiamond,
  "./line/basic-shape-hexagon.svg": basicShapeHexagon,
  "./line/basic-shape-primary-circle-ellipse-round.svg": basicShapePrimaryCircleEllipseRound,
  "./line/basic-shape-primary-square-rectangle.svg": basicShapePrimarySquareRectangle,
  "./line/basic-shape-shield.svg": basicShapeShield,
  "./line/computer-device-desktop-monitor.svg": computerDeviceDesktopMonitor,
  "./line/computer-device-desktop.svg": computerDeviceDesktop,
  "./line/computer-device-laptop.svg": computerDeviceLaptop,
  "./line/computer-device-mobile-phone-android-samsung-back.svg": computerDeviceMobilePhoneAndroidSamsungBack,
  "./line/computer-device-mobile-phone-android-samsung.svg": computerDeviceMobilePhoneAndroidSamsung,
  "./line/computer-device-mobile-phone-iphone-x-back.svg": computerDeviceMobilePhoneIphoneXBack,
  "./line/computer-device-mobile-phone-iphone-x.svg": computerDeviceMobilePhoneIphoneX,
  "./line/computer-device-mobile-tablet-touch.svg": computerDeviceMobileTabletTouch,
  "./line/computer-device-mobile-tablet.svg": computerDeviceMobileTablet,
  "./line/computer-device-network-ethernet-cat6.svg": computerDeviceNetworkEthernetCat6,
  "./line/computer-device-network-lan-www.svg": computerDeviceNetworkLanWww,
  "./line/computer-device-network-wifi-connection.svg": computerDeviceNetworkWifiConnection,
  "./line/computer-device-network-wifi-router.svg": computerDeviceNetworkWifiRouter,
  "./line/computer-keyboard-alt.svg": computerKeyboardAlt,
  "./line/computer-keyboard-command-cmd-control-ctrl.svg": computerKeyboardCommandCmdControlCtrl,
  "./line/computer-keyboard-option.svg": computerKeyboardOption,
  "./line/computer-keyboard-shift.svg": computerKeyboardShift,
  "./line/ecology-science-erlenmeyer-flask.svg": ecologyScienceErlenmeyerFlask,
  "./line/entertainment-control-button-circle-left-arrow-rewind.svg": entertainmentControlButtonCircleLeftArrowRewind,
  "./line/entertainment-control-button-circle-pause.svg": entertainmentControlButtonCirclePause,
  "./line/entertainment-control-button-circle-right-arrow-fast-forward.svg": entertainmentControlButtonCircleRightArrowFastForward,
  "./line/entertainment-control-button-circle-stop-square.svg": entertainmentControlButtonCircleStopSquare,
  "./line/entertainment-control-button-play-circle.svg": entertainmentControlButtonPlayCircle,
  "./line/entertainment-party-popper-confetti.svg": entertainmentPartyPopperConfetti,
  "./line/image-flash-lightning.svg": imageFlashLightning,
  "./line/image-photo-frame.svg": imagePhotoFrame,
  "./line/image-picture-flower.svg": imagePictureFlower,
  "./line/interface-add.svg": interfaceAdd,
  "./line/interface-alert-error-exclamation-block-square.svg": interfaceAlertErrorExclamationBlockSquare,
  "./line/interface-alert-error-x-block-square.svg": interfaceAlertErrorXBlockSquare,
  "./line/interface-alert-exclamation-diamond.svg": interfaceAlertExclamationDiamond,
  "./line/interface-alert-exclamation-triangle-warning.svg": interfaceAlertExclamationTriangleWarning,
  "./line/interface-alert-information-circle.svg": interfaceAlertInformationCircle,
  "./line/interface-award-crown.svg": interfaceAwardCrown,
  "./line/interface-bookmark-tag.svg": interfaceBookmarkTag,
  "./line/interface-bookmark.svg": interfaceBookmark,
  "./line/interface-calendar-date-one.svg": interfaceCalendarDateOne,
  "./line/interface-close.svg": interfaceClose,
  "./line/interface-content-book-open-pages.svg": interfaceContentBookOpenPages,
  "./line/interface-content-book-page.svg": interfaceContentBookPage,
  "./line/interface-content-file.svg": interfaceContentFile,
  "./line/interface-content-folder.svg": interfaceContentFolder,
  "./line/interface-copy-clipboard.svg": interfaceCopyClipboard,
  "./line/interface-delete-bin-trash.svg": interfaceDeleteBinTrash,
  "./line/interface-dots-horizontal.svg": interfaceDotsHorizontal,
  "./line/interface-dots-vertical.svg": interfaceDotsVertical,
  "./line/interface-edit-attachment.svg": interfaceEditAttachment,
  "./line/interface-edit-binocular.svg": interfaceEditBinocular,
  "./line/interface-edit-magic-wand.svg": interfaceEditMagicWand,
  "./line/interface-edit-tool-eraser.svg": interfaceEditToolEraser,
  "./line/interface-edit-tool-paint-brush.svg": interfaceEditToolPaintBrush,
  "./line/interface-edit-tool-paint-roller.svg": interfaceEditToolPaintRoller,
  "./line/interface-edit-tool-pen.svg": interfaceEditToolPen,
  "./line/interface-edit-tool-pencil.svg": interfaceEditToolPencil,
  "./line/interface-edit-view-eye.svg": interfaceEditViewEye,
  "./line/interface-favorite-award.svg": interfaceFavoriteAward,
  "./line/interface-favorite-flag.svg": interfaceFavoriteFlag,
  "./line/interface-favorite-heart.svg": interfaceFavoriteHeart,
  "./line/interface-favorite-star.svg": interfaceFavoriteStar,
  "./line/interface-favorite-stars-shining.svg": interfaceFavoriteStarsShining,
  "./line/interface-favorite-stars-sparkles.svg": interfaceFavoriteStarsSparkles,
  "./line/interface-hierarchy-flowchart.svg": interfaceHierarchyFlowchart,
  "./line/interface-home-house.svg": interfaceHomeHouse,
  "./line/interface-hyperlink.svg": interfaceHyperlink,
  "./line/interface-lighting-brightness.svg": interfaceLightingBrightness,
  "./line/interface-lock-closed.svg": interfaceLockClosed,
  "./line/interface-lock-open-unlock.svg": interfaceLockOpenUnlock,
  "./line/interface-login-key.svg": interfaceLoginKey,
  "./line/interface-search.svg": interfaceSearch,
  "./line/interface-setting-cog.svg": interfaceSettingCog,
  "./line/interface-share-megaphone-bullhorn.svg": interfaceShareMegaphoneBullhorn,
  "./line/interface-share-rocket.svg": interfaceShareRocket,
  "./line/interface-share-satellite.svg": interfaceShareSatellite,
  "./line/interface-share-space-ship.svg": interfaceShareSpaceShip,
  "./line/interface-share.svg": interfaceShare,
  "./line/interface-signal-square.svg": interfaceSignalSquare,
  "./line/interface-text-formatting-left-open-quote.svg": interfaceTextFormattingLeftOpenQuote,
  "./line/interface-text-formatting-right-close-quote.svg": interfaceTextFormattingRightCloseQuote,
  "./line/interface-time-clock-circle.svg": interfaceTimeClockCircle,
  "./line/interface-time-hour-glass.svg": interfaceTimeHourGlass,
  "./line/interface-users-multiple.svg": interfaceUsersMultiple,
  "./line/interface-validation-checkbox-square.svg": interfaceValidationCheckboxSquare,
  "./line/interface-weather-moon.svg": interfaceWeatherMoon,
  "./line/legal-justice-hammer-gavel.svg": legalJusticeHammerGavel,
  "./line/mail-chat-bubble-square.svg": mailChatBubbleSquare,
  "./line/mail-send-email-paper-airplane.svg": mailSendEmailPaperAirplane,
  "./line/mail-send-envelope.svg": mailSendEnvelope,
  "./line/mail-sign-hashtag.svg": mailSignHashtag,
  "./line/money-cashier-receipt.svg": moneyCashierReceipt,
  "./line/money-currency-dollar-pay.svg": moneyCurrencyDollarPay,
  "./line/money-graph-arrow-increase.svg": moneyGraphArrowIncrease,
  "./line/money-graph-bar-chart-increase.svg": moneyGraphBarChartIncrease,
  "./line/nature-ecology-leaf.svg": natureEcologyLeaf,
  "./line/phone-telephone.svg": phoneTelephone,
  "./line/programming-bug.svg": programmingBug,
  "./line/programming-cloud.svg": programmingCloud,
  "./line/programming-computer-database-server.svg": programmingComputerDatabaseServer,
  "./line/programming-computer-database.svg": programmingComputerDatabase,
  "./line/programming-module-four-layout.svg": programmingModuleFourLayout,
  "./line/programming-module-three.svg": programmingModuleThree,
  "./line/programming-module.svg": programmingModule,
  "./line/programming-script-code.svg": programmingScriptCode,
  "./line/shopping-cart.svg": shoppingCart,
  "./line/shopping-gift-present.svg": shoppingGiftPresent,
  "./line/shopping-shipping-box-parcel-package.svg": shoppingShippingBoxParcelPackage,
  "./line/tag-new-circle.svg": tagNewCircle,
  "./line/travel-map-earth-globe.svg": travelMapEarthGlobe
});
const iconsBrand = /* @__PURE__ */ Object.assign({
  "./brand/brand-adobe.svg": brandAdobe,
  "./brand/brand-amazon.svg": brandAmazon,
  "./brand/brand-browser-firefox.svg": brandBrowserFirefox,
  "./brand/brand-browser-googlechrome.svg": brandBrowserGooglechrome,
  "./brand/brand-creative-commons.svg": brandCreativeCommons,
  "./brand/brand-ecommerce-etsy.svg": brandEcommerceEtsy,
  "./brand/brand-ecommerce-patreon.svg": brandEcommercePatreon,
  "./brand/brand-ecommerce-shopify.svg": brandEcommerceShopify,
  "./brand/brand-ecommerce-wordpress.svg": brandEcommerceWordpress,
  "./brand/brand-gaming-nintendo-switch.svg": brandGamingNintendoSwitch,
  "./brand/brand-gaming-playstation.svg": brandGamingPlaystation,
  "./brand/brand-gaming-xbox-live.svg": brandGamingXboxLive,
  "./brand/brand-google-drive.svg": brandGoogleDrive,
  "./brand/brand-google-gmail.svg": brandGoogleGmail,
  "./brand/brand-google.svg": brandGoogle,
  "./brand/brand-music-itunes.svg": brandMusicItunes,
  "./brand/brand-music-soundcloud.svg": brandMusicSoundcloud,
  "./brand/brand-music-spotify.svg": brandMusicSpotify,
  "./brand/brand-office-dropbox.svg": brandOfficeDropbox,
  "./brand/brand-office-slack.svg": brandOfficeSlack,
  "./brand/brand-office-zoom.svg": brandOfficeZoom,
  "./brand/brand-payments-alipay.svg": brandPaymentsAlipay,
  "./brand/brand-payments-paypal.svg": brandPaymentsPaypal,
  "./brand/brand-payments-stripe.svg": brandPaymentsStripe,
  "./brand/brand-platform-android.svg": brandPlatformAndroid,
  "./brand/brand-platform-apple.svg": brandPlatformApple,
  "./brand/brand-platform-linux.svg": brandPlatformLinux,
  "./brand/brand-platform-microsoft-windows.svg": brandPlatformMicrosoftWindows,
  "./brand/brand-social-chat-discord.svg": brandSocialChatDiscord,
  "./brand/brand-social-chat-kuaishou.svg": brandSocialChatKuaishou,
  "./brand/brand-social-chat-line.svg": brandSocialChatLine,
  "./brand/brand-social-chat-messenger.svg": brandSocialChatMessenger,
  "./brand/brand-social-chat-signal.svg": brandSocialChatSignal,
  "./brand/brand-social-chat-snapchat.svg": brandSocialChatSnapchat,
  "./brand/brand-social-chat-telegram.svg": brandSocialChatTelegram,
  "./brand/brand-social-chat-wechat.svg": brandSocialChatWechat,
  "./brand/brand-social-chat-whatsapp.svg": brandSocialChatWhatsapp,
  "./brand/brand-social-media-deviantart.svg": brandSocialMediaDeviantart,
  "./brand/brand-social-media-dribbble.svg": brandSocialMediaDribbble,
  "./brand/brand-social-media-facebook.svg": brandSocialMediaFacebook,
  "./brand/brand-social-media-instagram.svg": brandSocialMediaInstagram,
  "./brand/brand-social-media-linkedin.svg": brandSocialMediaLinkedin,
  "./brand/brand-social-media-pinterest.svg": brandSocialMediaPinterest,
  "./brand/brand-social-media-reddit.svg": brandSocialMediaReddit,
  "./brand/brand-social-media-sina-weibo.svg": brandSocialMediaSinaWeibo,
  "./brand/brand-social-media-threads.svg": brandSocialMediaThreads,
  "./brand/brand-social-media-tiktok.svg": brandSocialMediaTiktok,
  "./brand/brand-social-media-tinder.svg": brandSocialMediaTinder,
  "./brand/brand-social-media-tumblr.svg": brandSocialMediaTumblr,
  "./brand/brand-social-media-twitter.svg": brandSocialMediaTwitter,
  "./brand/brand-software-design-figma.svg": brandSoftwareDesignFigma,
  "./brand/brand-software-development-authy.svg": brandSoftwareDevelopmentAuthy,
  "./brand/brand-software-development-digital-ocean.svg": brandSoftwareDevelopmentDigitalOcean,
  "./brand/brand-software-development-docker.svg": brandSoftwareDevelopmentDocker,
  "./brand/brand-software-development-github.svg": brandSoftwareDevelopmentGithub,
  "./brand/brand-software-development-jira.svg": brandSoftwareDevelopmentJira,
  "./brand/brand-software-development-openai.svg": brandSoftwareDevelopmentOpenai,
  "./brand/brand-software-development-stackexchange.svg": brandSoftwareDevelopmentStackexchange,
  "./brand/brand-software-development-stackoverflow.svg": brandSoftwareDevelopmentStackoverflow,
  "./brand/brand-video-netflix.svg": brandVideoNetflix,
  "./brand/brand-video-twitch.svg": brandVideoTwitch,
  "./brand/brand-video-vimeo.svg": brandVideoVimeo,
  "./brand/brand-video-youtube.svg": brandVideoYoutube,
  "./brand/programming-framework-angular.svg": programmingFrameworkAngular,
  "./brand/programming-framework-astro.svg": programmingFrameworkAstro,
  "./brand/programming-framework-laravel.svg": programmingFrameworkLaravel,
  "./brand/programming-framework-nextdotjs.svg": programmingFrameworkNextdotjs,
  "./brand/programming-framework-react.svg": programmingFrameworkReact,
  "./brand/programming-framework-vuedotjs.svg": programmingFrameworkVuedotjs,
  "./brand/programming-language-c.svg": programmingLanguageC,
  "./brand/programming-language-clojure.svg": programmingLanguageClojure,
  "./brand/programming-language-csharp.svg": programmingLanguageCsharp,
  "./brand/programming-language-css3.svg": programmingLanguageCss3,
  "./brand/programming-language-go.svg": programmingLanguageGo,
  "./brand/programming-language-html5.svg": programmingLanguageHtml5,
  "./brand/programming-language-java.svg": programmingLanguageJava,
  "./brand/programming-language-javascript-js.svg": programmingLanguageJavascriptJs,
  "./brand/programming-language-json.svg": programmingLanguageJson,
  "./brand/programming-language-kotlin.svg": programmingLanguageKotlin,
  "./brand/programming-language-node.svg": programmingLanguageNode,
  "./brand/programming-language-objc.svg": programmingLanguageObjc,
  "./brand/programming-language-ocaml.svg": programmingLanguageOcaml,
  "./brand/programming-language-php.svg": programmingLanguagePhp,
  "./brand/programming-language-powershell.svg": programmingLanguagePowershell,
  "./brand/programming-language-python.svg": programmingLanguagePython,
  "./brand/programming-language-r.svg": programmingLanguageR,
  "./brand/programming-language-ruby.svg": programmingLanguageRuby,
  "./brand/programming-language-scala.svg": programmingLanguageScala,
  "./brand/programming-language-shell.svg": programmingLanguageShell,
  "./brand/programming-language-swift.svg": programmingLanguageSwift,
  "./brand/programming-language-typescript.svg": programmingLanguageTypescript,
  "./brand/programming-tool-git.svg": programmingToolGit,
  "./brand/programming-tool-tailwindcss.svg": programmingToolTailwindcss
});
function mapLocalIcons(imported, group) {
  const formatted = Object.entries(imported).map(([filename, rawData]) => {
    const name = filename.replace("./solid/", "").replace("./line/", "").replace("./brand/", "").replace(".svg", "");
    const icon = {
      // Prefix the src with the group so that the final flat icon map has unique keys
      src: `${group}/${name}`,
      title: name.replaceAll("-", " "),
      group,
      tags: []
    };
    return {
      icon,
      rawData
    };
  });
  const iconDefinitionList = formatted.map((e) => e.icon);
  const iconDataMap = Object.fromEntries(
    formatted.map((e) => [e.icon.src, e.rawData])
  );
  return {
    iconDefinitionList,
    iconDataMap
  };
}
const solid = mapLocalIcons(iconsSolid, "solid");
const line = mapLocalIcons(iconsLine, "line");
const brand = mapLocalIcons(iconsBrand, "brand");
const localIconList = [
  ...solid.iconDefinitionList,
  ...line.iconDefinitionList,
  ...brand.iconDefinitionList
];
const localIconData = {
  ...solid.iconDataMap,
  ...line.iconDataMap,
  ...brand.iconDataMap
};
const getLocalIcon = (src) => {
  return localIconData[src];
};
export {
  getLocalIcon,
  localIconList
};
//# sourceMappingURL=localIcons.js.map
